export default __webpack_public_path__ + "static/Brelin-28488be8332a159b46d9f48e32fcba7b.png";